var _tspan, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportDamsLargeImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 364,
    height: 36,
    viewBox: "0 0 364 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 179387"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6749",
    style: {
      fill: "#f3f6f9",
      stroke: "#203662",
      strokeDasharray: "4 2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h364v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h363v35H.5z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173178"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Import from",
    transform: "translate(135 22)",
    style: {
      fill: "#66676b",
      fontSize: 12,
      fontFamily: "NunitoSans-Regular,Nunito Sans",
      letterSpacing: ".01em"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Import from"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173177"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21257",
    d: "M206.286 22H204v-8h2.286a2.286 2.286 0 0 1 2.286 2.286v3.429A2.286 2.286 0 0 1 206.286 22zm-1.143-1.143h1.143a1.143 1.143 0 0 0 1.143-1.143v-3.428a1.143 1.143 0 0 0-1.143-1.143h-1.143z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21258",
    d: "M214.286 14H212a1.143 1.143 0 0 0-1.143 1.143V22H212v-2.857h2.286V22h1.143v-6.857A1.143 1.143 0 0 0 214.286 14zM212 18v-2.857h2.286V18z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21259",
    d: "m221.143 14-.869 2.857-.274 1.131-.263-1.131-.88-2.857h-1.143v8h1.143v-4.571l-.091-1.143.331 1.143.9 2.646.9-2.646.331-1.143-.091 1.143V22h1.143v-8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21260",
    d: "M228 22h-3.429v-1.143H228v-2.286h-2.286a1.143 1.143 0 0 1-1.143-1.142v-2.286A1.143 1.143 0 0 1 225.714 14h3.429v1.143h-3.429v2.286H228a1.143 1.143 0 0 1 1.143 1.143v2.286A1.143 1.143 0 0 1 228 22z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportDamsLargeImage);
export default __webpack_public_path__ + "static/media/import-dams-large-image.6e1fa9ce290360dc0474130f82bd5360.svg";
export { ForwardRef as ReactComponent };